<template>
  <router-link :to="{ name: 'settingOfferAgreementShow', params: { id: item.id } }" tag="tr">
    <td>
      {{ item.name }}
    </td>
    <td>
      {{ type !== 'new' ? (item.published_at ? formatDate(item.published_at) : '-') : '' }}
    </td>
    <td>
      <div v-if="tryParseJSON(item.data)" class="languages">
        <template v-for="(lang, key) in JSON.parse(item.data)">
          <img v-if="lang.length" :key="key" :src="findObject(key).image.svg" alt="" />
        </template>
      </div>
      <div v-else>-</div>
    </td>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OfferAgreementTableItem',
  components: {},
  props: ['item', 'type'],
  data: () => ({}),
  computed: {
    ...mapGetters('languages', ['languages']),
  },
  methods: {
    tryParseJSON(jsonString) {
      try {
        var o = JSON.parse(jsonString)
        if (o && typeof o === 'object') {
          return o
        }
      } catch (e) {}

      return false
    },
    formatDate(date) {
      if (!date) return null
      const [dateOnly, time] = date.split(' ')
      const [year, month, day] = dateOnly.split('-')
      return `${day}.${month}.${year}` + ' ' + time
    },
    findObject(id) {
      const key = Object.keys(this.languages).filter((i) => this.languages[i].id == id)
      return this.languages[key]
    },
  },
}
</script>

<style lang="scss" scoped>
td {
  .languages {
    display: flex;
    img {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border: 1px solid #bedbebb4;
      -o-object-fit: cover;
      object-fit: cover;
      &:not(:last-of-type) {
        margin-right: 12px;
      }
    }
  }
}
</style>
